/**
 * index.js — React application entry point
 * ==========================================
 * Bootstraps the React 18 root and wraps the entire app in the
 * Google OAuth provider so any component in the tree can trigger
 * the Google login flow without additional setup.
 *
 * Environment variables required
 * --------------------------------
 * REACT_APP_GCP_JWT_CLIENT_ID  — OAuth 2.0 client ID from Google Cloud Console.
 *   Used by @react-oauth/google to initiate the sign-in flow and validate the
 *   returned JWT credential before it is exchanged with the backend.
 *
 * StrictMode note
 * ---------------
 * React.StrictMode is intentionally commented out.  It causes components to
 * mount/unmount twice in development, which breaks certain third-party libraries
 * (e.g. react-leaflet, react-apexcharts) that do not tolerate double-mount.
 * Re-enable during refactoring sprints to surface side-effect bugs.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

// Mount the React tree into the #root div defined in public/index.html.
// createRoot is the React 18 API — it enables concurrent features.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GCP_JWT_CLIENT_ID}>
    {/* <React.StrictMode> */}
    <App />
    {/* </React.StrictMode> */}
  </GoogleOAuthProvider >
);

// Pass a callback here to collect Core Web Vitals metrics.
// e.g. reportWebVitals(console.log) or send to an analytics endpoint.
// See reportWebVitals.js for the full list of metrics collected.
reportWebVitals();
